import {Component, Input, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {RxComponent} from '../../../../../../core/components/common/rx.component';
import {CertificatesService} from '../../../certificates.service';
import {DynamicGridField} from '../../../../../../shared/components/dynamic-grid/dynamic-grid.component';
import {ConfigService} from '../../../../../../core/services/config.service';

@Component({
    selector: 'itpx-certificates-issued',
    templateUrl: './certificates-issued.component.html',
    styleUrls: ['./certificates-issued.component.css']
})
export class CertificatesIssuedComponent extends RxComponent implements OnInit {

    @Input() certificateTemplateId: string;

    gridRefresh = new ReplaySubject<boolean>(1);

    fields: DynamicGridField[];
    selectedIssueDate: string;
    selectedExpirationDate: string;

    url: string;
    emptyMessage: string;
    issuingDateFilterConfig = {
        title: 'Issue Date',
        key: 'issueDate',
        options: [],
        config: {
            dateFilter: true
        }
    };
    expirationDateFilterConfig = {
        title: 'Expiration Date',
        key: 'expDate',
        options: [],
        config: {
            dateFilter: true
        }
    };

    constructor(
        private service: CertificatesService,
        private configService: ConfigService
    ) {
        super();
    }

    ngOnInit() {

        this.getIssuedCertificates();
    }

    onFilterChanges(date, type) {
        if(date) {
            if (type === 'issueDate') {
                this.selectedIssueDate = typeof date === 'string' ? date : null;
            } else if (type === 'expirationDate') {
                this.selectedExpirationDate = typeof date === 'string' ? date : null;
            }
            this.url = this.service.getCertificatesIssued(
                this.certificateTemplateId,
                this.selectedIssueDate,
                this.selectedExpirationDate
            );
            this.refreshGrid();
        }
    }


    public download(item) {
        const link = this.configService.getSphinxUrlUnsecured('sahara', item.awsBucket, item.awsKey);
        window.open(link);
    }

    private getIssuedCertificates(): void {
        this.fields = this.service.certificatesIssuedFields();
        this.emptyMessage = 'No certificates issued';
        this.url =  this.service.getCertificatesIssued(this.certificateTemplateId, null, null);
        this.refreshGrid();
    }

    private refreshGrid(): void {
        setTimeout(() => {
            this.gridRefresh.next(true)
        }, 50);
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/certificates/components/details/certificates-issued/certificates-issued.component.ts